import { render, staticRenderFns } from "./PaymentsFlux.vue?vue&type=template&id=8c59ba26&"
import script from "./PaymentsFlux.vue?vue&type=script&lang=js&"
export * from "./PaymentsFlux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c59ba26')) {
      api.createRecord('8c59ba26', component.options)
    } else {
      api.reload('8c59ba26', component.options)
    }
    module.hot.accept("./PaymentsFlux.vue?vue&type=template&id=8c59ba26&", function () {
      api.rerender('8c59ba26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/PaymentsFlux.vue"
export default component.exports